<template>
  <div class="main">
    <div id="lang" v-if="formTranslation" style="display: block;"> 
      <ul :id="`selector-${formTranslation.translationRenderMode}`" 
        v-if="['label-only', 'label-with-seperator', 'image-only', 'image-with-seperator'].includes(formTranslation.translationRenderMode)"
      >
        <li v-for="transLang in formTranslation.translationLanguagesSet"
          :key="transLang.langName"
          :id="`transLang_${transLang.langName}`"
          :name="`transLang_${transLang.langName}`"
          @click="switchLanguage(transLang.langName)"
          :class="{'selected': selectedLanguage === transLang.langName}"
        >
          {{(['label-only', 'label-with-seperator'].includes(formTranslation.translationRenderMode)) ? transLang.label : ''}}
          <img v-if="['image-only', 'image-with-seperator'].includes(formTranslation.translationRenderMode)"
            :src="transLang.flag_image"
            :style="transLang.image_style ? transLang.image_style : 'width:30px;'"
          >
        </li>
      </ul>
    </div>
    <v-style>{{ formStyle }}</v-style>
    <div class="form">
      <input v-for="yesnogroupField in yesnogroupFields"
        :key="yesnogroupField.name"
        type="hidden"
        :id="`${yesnogroupField.name}_yesnovalue`" 
        :ref="`${yesnogroupField.name}_yesnovalue`"
        value="">
      <div class="form-message" v-if="isSubmitted && formAction === 'Display message'">{{ formMessage }}</div>
      <div v-if="isLoading">
        <spinner></spinner> 
      </div>
      <div class="form-content">
        <div class="somethingwrong">
          <b-alert
            variant="danger"
            dismissible
            :show="showErrorAlert"
            @dismissed="showErrorAlert = false"
          >
            <div v-html="errorMsg" class="errorMsg"></div>
          </b-alert>
        </div>
        <b-form @submit="onSubmit" @reset="onReset">
          <div :id="`${mutableFormId}_fb-template`"></div>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>

import Vue from 'vue';
import { apigClient } from '@/shared/api';
import { formBuilder } from "formBuilder";
import { imageHolder } from "../form-builder/img.js";
import { controlLinkHolder } from "../form-builder/hreflink.js";
import { controlMetaHolder } from "../form-builder/meta.js";
import { controlYesNoGroupHolder } from "../form-builder/custom-controls/yesnogroup.js";
import { controlRedirectInXSec } from "../form-builder/custom-controls/redirectInXSec.js";
import { switchLanguageOnFields } from '../form-builder/helpers/js/fieldLanguageChange';
import { embedMetadataToElement } from '../form-builder/helpers/js/embedMetadata';

const Spinner = () => import('../shared/Spinner');
const formRender = require('formBuilder/dist/form-render.min.js');

Vue.component('v-style', {
  render: function (createElement) {
    return createElement('style', this.$slots.default)
  }
});

export default {
  components: {
    Spinner
  },
  props: {
    formId: {
      type: String,
      required: false
    },
    formCode: {
      type: String,
      required: false
    },
    campaignId: {
      type: String,
      required: false
    },
    techId: {
      type: String,
      required: false
    },
    campaignName: {
      type: String,
      required: false
    },
    wronglyTypedProtectCode:{
      type: String,
      required: false
    },
    qrLink:{
      type: String,
      required: false
    },
    ipCountry: {
      type: String,
      required: false
    },
    trackingInfo:{
      type: Object,
      required: false
    },
    campaignRetainSelectedLanguage: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      mutableFormId: this.formId,
      mutableFormCode: this.formCode,
      mutableCampaignId: this.campaignId,
      mutableIpCountry: this.ipCountry,
      mutableCampaignRetainSelectedLanguage: this.campaignRetainSelectedLanguage,
      formStyle: '',
      isSubmitted: false,
      isLoading: false,
      formRenderOptions: {
        formData: []
      },
      yesnogroupFields: [],
      redirectInXSecField: null,
      formName: null,
      formType: null,
      formMessage: null,
      formAction: null,
      formTranslation: null,
      selectedLanguage: null,
      fbBuilder: {},
      showErrorAlert: false,
      errorMsg: null,
      metaInformation: {},
      metadataId: null
    };
  },
  created: function() {},
  mounted: async function() {
    let that = this;
    await that.loadData();
  },
  computed: {
  },
  methods: {
    autoSelectLanguage(){
      let that = this;
      if(that.formTranslation && that.formTranslation.translationLanguagesSet){
        if(that.ipCountry && !that.campaignRetainSelectedLanguage){
          console.log('Set IP Country Language: ', that.ipCountry);
          let translationLanguagesSet = that.formTranslation.translationLanguagesSet;
          let ipCountryInTheTranslationList = translationLanguagesSet.find(t=> t.countries.includes(that.ipCountry));
          if(ipCountryInTheTranslationList && ipCountryInTheTranslationList.langName){
            that.switchLanguage(ipCountryInTheTranslationList.langName);
          }else{
            // Choose default language en
            that.switchLanguage('en');
          }
        } else if(that.ipCountry && that.campaignRetainSelectedLanguage){
          console.log('Retained Language: ', that.campaignRetainSelectedLanguage)
          let translationLanguagesSet = that.formTranslation.translationLanguagesSet;
          let selectedLangInTranslationList = translationLanguagesSet.find(t=> t.langName === that.campaignRetainSelectedLanguage);
          if(selectedLangInTranslationList){
            that.switchLanguage(that.campaignRetainSelectedLanguage);
          }
        }
      }
    },
    switchLanguage(langName){
      console.log('switched lang: ', langName);
      this.selectedLanguage = langName;
      switchLanguageOnFields(this.selectedLanguage, this.formTranslation);
      this.$emit('onTranslationLangSelected', {
        selectedLanguage: this.selectedLanguage,
      });
    },
    resetData() {
      let that = this;
      that.formStyle = '';
      that.isSubmitted = false;
      that.isLoading = false;
      that.formRenderOptions.formData = [];
      that.formName = null;
      that.formType = null;
      that.formMessage = null;
      that.formAction = null;
      that.fbBuilder = {};
      that.showErrorAlert = false;
      that.errorMsg = null;
    },
    loadData: async function(formId='',formCode='',campaignId=''){
      let that = this;
      that.resetData();
      that.showErrorAlert = false;
      that.errorMsg = null;
      that.mutableFormId = formId || that.formId;
      that.mutableFormCode = formCode || that.formCode;
      that.mutableCampaignId = campaignId || that.campaignId;
      if(that.mutableFormId || that.mutableFormCode ){
        let responseObjects = await that.getData();
        that.formRenderOptions = {
          formData: responseObjects
        }
        that.yesnogroupFields = that.formRenderOptions.formData.filter(f => f.type==='yesnogroup');
        that.redirectInXSecField = that.formRenderOptions.formData.find(f => f.type==='redirectInXSec');
        let checkMetadata = this.formRenderOptions.formData.filter(f => f.type === 'Metadata');
        that.fbBuilder = $('#'+that.mutableFormId+"_fb-template").formRender(that.formRenderOptions);
        that.$emit('loadend', {
          status: "form is Loaded",
          formContent: responseObjects
        });
        if(checkMetadata.length > 0){
          that.metadataId = checkMetadata[0].name
          await that.mapMetadata(checkMetadata);
        }
        that.autoSelectLanguage();

        that.redirectInXSec(that.redirectInXSecField);
      }
    },
    redirectInXSec(field){
      let that = this;
      if(field && field.redirectInSeconds){
        if(!field.showMessage){
          $("#" + field.name + "_redirectInXSec").parent().hide();
        }
        let showMessage = field.showMessage;
        let remainingSecs = parseInt(field.redirectInSeconds);
        const countdown = setInterval(() => {
          remainingSecs--;
          if(showMessage){
            document.getElementById(`${field.name}_redirectInSeconds`).innerHTML = remainingSecs;
          }
          if (remainingSecs <= 0) {
            clearInterval(countdown);
            that.onSubmit();
          }
        }, 1000);
      }
    },
    getData(){
      let that = this;
      let method = 'GET';
      let pathTemplate = (that.mutableFormCode) ? '/formBuilder/byCode/' + that.mutableFormCode : '/formBuilder/' + that.mutableFormId;
      let additionalParams ={};
      if(that.mutableFormId){
        additionalParams = {
          queryParams: {
            params: JSON.stringify({
              filter: [
                {
                  fieldname: "isDeleted",
                  comparisonOperator: "=",
                  value: false
                }
              ]
            })
          }
        };
      }
      let pathParams = {};
      this.isLoading = true;
      
      return apigClient.invokeApi(pathParams, pathTemplate, method, additionalParams)
        .then(function(result) {
          let response = result.data;
          that.isLoading = false;
          if (response.status) {
            document.title = response.data.formName;
            that.mutableFormId = response.data.id;
            that.formName = response.data.formName;
            that.formType = response.data.formType;
            that.formMessage = response.data.formMessage;
            that.formAction = response.data.formAction;
            that.formStyle = response.data.formStyle;
            that.formTranslation = (response.data.formTranslation && response.data.formTranslation !== "NULL") ? JSON.parse(response.data.formTranslation) : null;
            return response.data.formContent;
          } else {
            console.log(
              `Error found from API Endpoint on Form Loading: ${response.message}`
            );
            that.errorMsg = `Error! Something went wrong on form loading: ${response.message}`;
            that.showErrorAlert = true;
            that.$emit('error', {status: "error"});
            return response.message;
          }
        }).catch( function(error){
          that.isLoading = false;
          console.log("invokeAPI Error on Form Loading: " + error.message);
          that.errorMsg = "Error! Something went wrong on form loading " + error.message;
          that.showErrorAlert = true;
          that.$emit('error', {status: "error"});
          return error.message;
        });
    },
    async mapMetadata(checkMetadata){
      if (checkMetadata.length > 0) {
        let responseMetaObject = await this.getMetaData(this.techId);
        if (responseMetaObject) {
          if (checkMetadata[0].value && checkMetadata[0].value !== '') {
            let metaList = checkMetadata[0].value.replace(', ', ',').split(',');
            metaList.map(d => metaArray.push(d.trim()));
            Object.keys(responseMetaObject).map(key => {
              if (metaList.indexOf(key) > -1) {
                this.metaInformation[key] = responseMetaObject[key];
              }
            });
          } else {
            Object.keys(responseMetaObject).map(key => {
              this.metaInformation[key] = responseMetaObject[key];
            });
          }
        }
        embedMetadataToElement(this.metaInformation, this.metadataId);
        this.$forceUpdate();
      }
    },
    getMetaData(techId){
      var method = 'GET';
      var pathTemplate = '/metadata/' + techId;
      var additionalParams ={};
      var pathParams = {};
      this.isLoading = true;
      var that = this;
      return apigClient.invokeApi(pathParams, pathTemplate, method, additionalParams)
        .then(function(result) {
          let response = result.data;
          that.isLoading = false;
          if (response.status) {
            return response.data.metadata;
          } else {
            return response.message;
          }
        }).catch( function(error){
          that.isLoading = false;
          return error.message;
        });
    },
    saveYesNoGroupFieldsDecisionUserData(objects){
      let that = this;
      if(that.yesnogroupFields) {
        that.yesnogroupFields.forEach(yesnogroupfield => {
          yesnogroupfield.userData = [];
          let yesnoValue = that.$refs[`${yesnogroupfield.name}_yesnovalue`][0].value;
          yesnoValue = (yesnoValue) ? yesnoValue : 'NULL';
          yesnogroupfield.userData.push(yesnoValue);
          objects.push(yesnogroupfield);

          that.$refs[`${yesnogroupfield.name}_yesnovalue`][0].value = '';
        });
      }
    },
    saveRedirectInXSecondsFieldUserData(objects){
      let that = this;
      if(that.redirectInXSecField){
        that.redirectInXSecField.userData = [];
        that.redirectInXSecField.userData.push(`Redirected To Next Content after ${that.redirectInXSecField.redirectInSeconds} second(s).`);
        objects.push(that.redirectInXSecField);
      }
    },
    post(objects, content) {
      let that = this;
      that.saveYesNoGroupFieldsDecisionUserData(objects);
      that.saveRedirectInXSecondsFieldUserData(objects);
      
      let body = {
        form_id: this.formId,
        campaign_id: this.campaignId,
        campaignName: this.campaignName,
        wronglyTypedProtectCode: this.wronglyTypedProtectCode,
        qrLink: this.qrLink,
        scanCity: (that.trackingInfo["geo-city"] && that.trackingInfo["geo-city"] !== '') ? 
                   that.trackingInfo["geo-city"] : that.trackingInfo["ip-city"],
        scanCountry: (that.trackingInfo["geo-country"] && that.trackingInfo["geo-country"] !== '') ?
                      that.trackingInfo["geo-country"] : that.trackingInfo["ip-country"],
        form_data: objects,
        forEmailSendingAction:{
          formNamePattern: "{{formName}}",
          formCodePattern: "{{formCode}}",
          campaignNamePattern: "{{campaignName}}",
          campaignQRLinkPattern: "{{campaign-qr-link}}",
          campaignWronglyTypedProtectCodePattern: "{{campaign-wrongly-typed-protectCode}}",
          scanCityPattern: "{{scan-city}}",
          scanCountryPattern: "{{scan-country}}",
          subjectTemplate: "",
          availableFieldTypes : ['text', 'number', 'date', 'radio-group', 'checkbox-group', 'select', 'textarea']
        }
      }
      this.isLoading = true;
      let method = 'POST';
      let pathTemplate = '/formBuilderResults';
      let additionalParams ={};
      let pathParams = {};
      this.isLoading = true;
      apigClient.invokeApi(pathParams, pathTemplate, method, additionalParams, body)
        .then(function(result){
          if (result.data.status) {
            that.isSubmitted = true;
            that.isLoading = false;
            if (that.formAction === 'Redirect URL') {
              window.location.href = that.formMessage;
              return;
            } else if (that.formAction === 'Display message') {
              window.scrollTo(0, 0);
              that.$emit('toggle', {
                formId: that.formId,
                formName: that.formName,
                formType: that.formType,
                formContent: content, 
                formAction: that.formAction,
                formResult: objects
              });
              return;
            } else{
              that.$emit('toggle', {
                formId: that.formId,
                formName: that.formName,
                formType: that.formType,
                formContent: content, 
                formAction: that.formAction,
                formResult: objects
              });
            }
          } else {
            console.log(
              `Error found from API Endpoint on Form Submit: ${result.data.message}`
            );
            that.errorMsg = "Error! Something went wrong on form submit: " + result.data.message;
            that.showErrorAlert = true;
            that.isLoading = false;
            that.$emit('error', {status: "error"});
          }
        }).catch(function(result){
          that.isSubmitted = false;
          that.isLoading = false;
          console.log("invokeAPI Error on Form submit: " + result.message);
          that.errorMsg = "Error! Something went wrong on form submit: " + result.message;
          that.showErrorAlert = true;
          that.$emit('error', {status: "error"});
        });
    },
    cleanFormObject(objs) {
      let saveObject = [];
      return objs.filter(function(item){
        return item.userData;
      });
    },
    onSubmit(evt) {
      let that = this;
      if(evt) evt.preventDefault();
      that.$emit('submit', {status: "submitting"});
      let content = $('#fb-template').formRender('userData');
      let result = that.cleanFormObject(content);
      that.post(result, content);
    },
    onReset(evt) {
      evt.preventDefault();
    }
  }
};
</script>
<style scoped lang="scss">
  @import '@/views/form-builder/helpers/style/formBuilder.less';
</style>
